export enum FAMILIES {
  DEFAULT = 'Roboto, Helvetica, Arial, Verdana, Tahoma, sans-serif'
}

export default FAMILIES;